import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'app-az-date-picker',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './az-date-picker.component.html',
  styleUrl: './az-date-picker.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AzDatePickerComponent),
      multi: true,
    },
  ],
})
export class AzDatePickerComponent implements ControlValueAccessor {
  @Input() label: string = '';
  @Input() id: string = 'date-picker';
  @Input() value: string = '';
  @Input() disabled: boolean = false;
  @Output() valueChange = new EventEmitter<string>();

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  onDateChange(newValue: string): void {
    if (this.disabled) return;
    this.value = newValue;
    this.valueChange.emit(newValue);
    this.onChange(newValue);
  }

  writeValue(value: string): void {
    this.value = value || '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
